import React, { Component } from 'react';
import './ResultListBox.css'
import ResultListTable from './ResultListTable';
import Pagination from "react-js-pagination";

export default class ResultListBox extends Component {
    // constructor(props) {
    //     super(props);

    //     this.state = {};
    // }
    handleRecPerPageChange = (e) => {
        this.props.onRecPerPageChange(e.target.value);
    }
    handlePageChange = (pageno) => {
        this.props.onPageChange(pageno);
    }
    handleSort = (col) => {
        this.props.onSort(col);
    }
    clearAll = ()=>{
        this.props.clearAll();
    }
    render() {
        return (
            <div className="ResultListBox">
                <div className="resultinfo2"><div style={{display:"flex"}}>該当銘柄 <span className="count">{this.props.data.count}</span> 件  {this.props.pageno}ページ目（{this.props.data.count===0?0:((this.props.pageno-1)*this.props.recperpage+1)}～{(this.props.pageno*this.props.recperpage<this.props.data.count)?this.props.pageno*this.props.recperpage:this.props.data.count}件表示）<div className="clearAll"  onClick={this.clearAll}>全条件をクリア</div></div>
                <div className="nppbox"><label className="label" ><select onChange={this.handleRecPerPageChange} value={this.props.recperpage}><option>20</option><option>50</option></select></label>件表示</div>
                </div>
                <div className="updateinfo">最終更新日時：{this.props.data.update} </div>
                <div className="paging">
                    <Pagination
                        activePage={this.props.pageno}
                        itemsCountPerPage={this.props.recperpage}
                        totalItemsCount={this.props.data.count}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChange}
                        prevPageText="前へ"
                        nextPageText="次へ"
                        firstPageText="最初へ"
                        lastPageText="最後へ"
                    />
                </div>
                <div style={{ clear: 'both' }} />
                <ResultListTable token={this.props.token} appId={this.props.appId} criteria={this.props.criteria} data={this.props.data.data} advancedQueue={this.props.advancedQueue} recperpage={this.props.recperpage} sortby={this.props.sortby} sortorder={this.props.sortorder} onSort={this.handleSort} />
                <div className="paging">
                    <Pagination
                        activePage={this.props.pageno}
                        itemsCountPerPage={this.props.recperpage}
                        totalItemsCount={this.props.data.count}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChange}
                        prevPageText="前へ"
                        nextPageText="次へ"
                        firstPageText="最初へ"
                        lastPageText="最後へ"
                    />
                </div>
            </div>
        );
    }
}